var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificationTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_1012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 3.32812C12.6094 3.87513 12.8267 4.39974 13.2135 4.78653C13.6003 5.17333 14.1249 5.39062 14.6719 5.39062C15.2189 5.39062 15.7435 5.17333 16.1303 4.78653C16.5171 4.39974 16.7344 3.87513 16.7344 3.32812C16.7344 2.78112 16.5171 2.25651 16.1303 1.86972C15.7435 1.48292 15.2189 1.26563 14.6719 1.26562C14.1249 1.26563 13.6003 1.48292 13.2135 1.86972C12.8267 2.25651 12.6094 2.78112 12.6094 3.32812Z",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.05965 1.44987C4.08776 1.39452 4.13065 1.34804 4.18355 1.31557C4.23646 1.2831 4.29733 1.26591 4.3594 1.26591C4.42148 1.26591 4.48235 1.2831 4.53525 1.31557C4.58816 1.34804 4.63105 1.39452 4.65915 1.44987L5.35628 2.85375C5.38039 2.90191 5.41581 2.94352 5.45951 2.97501C5.50322 3.0065 5.55389 3.02693 5.60722 3.03456L7.1699 3.26006C7.2309 3.26882 7.28827 3.29435 7.33561 3.3338C7.38295 3.37325 7.41841 3.42508 7.43803 3.4835C7.45716 3.54169 7.4595 3.60409 7.44479 3.66356C7.43008 3.72302 7.3989 3.77713 7.35484 3.81968L6.22047 4.91968C6.18237 4.95662 6.15383 5.00227 6.1373 5.05269C6.12077 5.10311 6.11675 5.1568 6.12559 5.20912L6.39303 6.75943C6.40343 6.82019 6.39642 6.88264 6.37282 6.93957C6.34921 6.99651 6.30998 7.04561 6.25965 7.08118C6.20895 7.1171 6.1493 7.1383 6.08729 7.14242C6.02529 7.14655 5.96336 7.13344 5.90834 7.10456L4.51547 6.37718C4.46737 6.35178 4.4138 6.3385 4.3594 6.3385C4.30501 6.3385 4.25144 6.35178 4.20334 6.37718L2.81253 7.10456C2.75751 7.13344 2.69558 7.14655 2.63358 7.14242C2.57157 7.1383 2.51192 7.1171 2.46122 7.08118C2.41089 7.04561 2.37165 6.99651 2.34805 6.93957C2.32445 6.88264 2.31744 6.82019 2.32784 6.75943L2.59528 5.20912C2.60411 5.1568 2.6001 5.10311 2.58357 5.05269C2.56704 5.00227 2.5385 4.95662 2.5004 4.91968L1.36878 3.81968C1.32472 3.77713 1.29354 3.72302 1.27883 3.66356C1.26411 3.60409 1.26646 3.54169 1.28559 3.4835C1.30514 3.42504 1.34058 3.37317 1.38793 3.33371C1.43528 3.29425 1.49269 3.26875 1.55372 3.26006L3.11572 3.03456C3.1683 3.02631 3.21815 3.00559 3.26108 2.97413C3.30402 2.94268 3.33881 2.9014 3.36253 2.85375L4.05965 1.44987Z",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6719 1.26562H7.45312",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 3.32812V13.6406C12.6094 14.4611 12.2834 15.248 11.7032 15.8282C11.123 16.4084 10.3361 16.7344 9.51562 16.7344H1.26562C1.6719 16.7344 2.0742 16.6544 2.44955 16.4989C2.8249 16.3434 3.16596 16.1155 3.45324 15.8282C3.74052 15.541 3.9684 15.1999 4.12388 14.8246C4.27935 14.4492 4.35938 14.0469 4.35938 13.6406V9.51562",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42188 12.6094H10.5469",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42188 10.5469H10.5469",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 8.48438H10.5469",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 6.42188H10.5469",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_1012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificationTracker);
export default __webpack_public_path__ + "static/media/Certification Tracker .7722cb73527a5e75d1ff54763c26a31c.svg";
export { ForwardRef as ReactComponent };